/**
 * ヘッダー
 *************************************************/
import { Auth } from 'aws-amplify';
import Footer from 'components/common/Footer';
import React, { FC, useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Container, Menu } from 'semantic-ui-react';

type LocationState = {
  role: string;
};
const Header: FC = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();

  // 現在ページのディレクトリ名を取得
  const path = location.pathname.split('/');
  const dir = path[path.length - 1];

  /**
   * メニューリンク押下時の処理
   */
  const nextPage = useCallback(
    (param: string) => {
      history.push(`/admin/${param}`);
    },
    [history],
  );

  /**
   * ログアウト処理
   */
  const logOut = useCallback(() => {
    Auth.signOut();
    history.push('/');
  }, [history]);

  useEffect(() => {
    (async () => {
      try {
        // 管理者ユーザーでない場合はログイン画面へリダイレクト
        const user = await Auth.currentAuthenticatedUser();
        if (!user.attributes['custom:role'] || user.attributes['custom:role'] !== 'admin') {
          history.push('/');
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [history]);

  return (
    <>
      <Menu size="large" inverted>
        <Container>
          <Menu.Item as="a" active={dir === 'score'} onClick={() => nextPage('score')}>
            試験結果確認
          </Menu.Item>
          <Menu.Item as="a" active={dir === 'registuser'} onClick={() => nextPage('registuser')}>
            受験者登録
          </Menu.Item>
          <Menu.Item position="right">
            <Button icon="sign-out" color="red" content="ログアウト" onClick={logOut} />
          </Menu.Item>
        </Container>
      </Menu>
      <Footer />
    </>
  );
};
export default Header;
